export const headerHeight = 90;
export const greenLight = '#1dc2a4';
export const greenDark = '#149e83';
export const ligthTextColor = '#ffffff';
export const eventsHeader = 'transparent';
export const featuresHeader = '#b041ba';
export const aboutHeader = 'unset';
export const transparentBackground = 'transparent';
export const statsColor = '#BF00D0';
export const liveWithKin = '#ff63ac';
export const appsColor = '#6f41e8';
export const purple = '#6f41e8';
export const purpleLight = '#936bfb';
export const blackish = '#1f1f1f';
export const bodyColor = '#fff3f3';
export const volcanoRed = '#b30606';
export const purpleTransed = 'rgba(167, 147, 223, 0.11)';
export const purpleTransedB = 'rgba(167, 147, 223, 0.2)';
export const silverado = '#f7f7f7';

export const transactionFormBottomMargins = {
	destinationAccount: '73px',
	kinAmount: '52px'
};
